import React from 'react'
import { KYCformStepsContextProvider } from '../../context/KYCformContext'
import { KYCformStepRoutes } from '../../routes/KYCform/KYCform'

export default function KYCformWithStepsContext() {
  return (
    <KYCformStepsContextProvider>
      <KYCformStepRoutes />
    </KYCformStepsContextProvider>
  )
}
